import axios from "axios";
import { Markup } from "interweave";
import moment from "moment";
import React, { useEffect, useState } from "react";
import ReactPlayer from "react-player";
import swal from "sweetalert";
import noImage from "../../../../assets/images/settings/no-image.png";
import PriceTag from "../../../../assets/images/tagPrice.PNG";
import LoaderPost from "../../../Reuseable/LoaderPost";
import "./StarGreetingsCompletedList.css";
import Nodata from "../../../../assets/Icon/Nodata.png";
import { serverInfo } from "../../../../App";
import { useContext } from "react";
import ReactPaginate from "react-paginate";
import BaseReactPlayer from "react-player";
const StarGreetingsCompletedList = () => {
  const { imageCdnUrl, videoCdnUrl } = useContext(serverInfo);

  const [loading, setloading] = useState(true);
  const [greeting, setGreeting] = useState({});
  const [greetingList, setGreetingList] = useState([]);
  const [Checked, setChecked] = useState([]);
  const [regGreId, setregGreId] = useState([]);
  const [modalShowl, setModalShowl] = useState(false);
  const [currentItems, setCurrentItems] = useState([]);
  const [pageCount, setPageCount] = useState(0);
  const [itemOffset, setItemOffset] = useState(0);
  const itemsPerPage = 5;
  const data = greetingList;
  useEffect(() => {
    const endOffset = itemOffset + itemsPerPage;
    setCurrentItems(data.slice(itemOffset, endOffset));
    setPageCount(Math.ceil(data.length / itemsPerPage));
  }, [itemOffset, itemsPerPage, data]);

  const handlePageClick = (event) => {
    const newOffset = (event.selected * itemsPerPage) % data.length;
    setItemOffset(newOffset);
  };
  useEffect(() => {
    getAllGreetingRegWithPayment();
  }, [modalShowl]);

  const getAllGreetingRegWithPayment = () => {
    axios.get("/sanctum/csrf-cookie").then((response) => {
      axios.get("/api/star/greetings_video_uploaded_list").then((res) => {
        if (res.data.status === 200) {
          setGreetingList(res.data.list);
          setGreeting(res.data.greeting);
        } else {
          swal("error", "Data base Error", "error");
        }
        setloading(false);
      });
    });
  };
  return (
    <>
      {loading === true ? (
        <LoaderPost />
      ) : (
        <>
          {Object.keys(greeting).length != 0 ? (
            <>
              <div className="row mx-2">
                <div className="col-md-7 mb-3 ">
                  <div className="card card-bg p-2">
                    <img
                      src={
                        greeting?.banner
                          ? imageCdnUrl+greeting?.banner
                          : noImage
                      }
                      alt=""
                      className=" img-fluid banner_re"
                    />
                  </div>
                </div>
                <div className="col-md-5 mb-3">
                  <div className="card card-bg p-2">
                    <ReactPlayer
                      className="ReactNAv"
                      url={
                        greeting?.video
                          ? videoCdnUrl + greeting?.video
                          : ""
                      }
                      width="100%" // height="100%" playing={false}
                      volume={1}
                      height="330px"
                      controls={true}
                      autoPlay
                    />
                  </div>
                </div>
              </div>
              <div className="mt-3 row mx-2">
                <div className="col-md-7 mb-3 ">
                  {currentItems?.length !== 0 ? (
                    <>
                      <div className="card-bg px-2 card">
                      <div className="NotifyOver w-100 mb-5">
                        
                          <table
                            className="w-100 my-3 NotifyTabletd "
                          >
                            <thead>
                              <tr className="NotifyTable mx-3 text-center">
                                <th>User</th>
                                <th>Request Date</th>
                                <th>Purpose</th>
                                <th>Video</th>
                              </tr>
                            </thead>
                            <tbody>
                            {currentItems.map((data, index) => (
                              <tr className="NotifyTable mx-3" key={index}>
                                <td className="Notifytdx lNTS">
                                  {" "}
                                  <img
                                    src={
                                      data.user?.image != null
                                        ? imageCdnUrl + data.user?.image
                                        : noImage
                                    }
                                    className="NotifyAimg"
                                    alt="profile"
                                  />
                                  {data.user?.first_name} {data.user?.last_name}
                                </td>
                                <td className="Notifytdx">
                                  {moment(data.request_time).format("LLL")}
                                </td>
                                <td className="Notifytdx">{data.purpose}</td>
                                <td className="Notifytdx">
                                  {data?.video ? <BaseReactPlayer
                                    url={videoCdnUrl + data?.video}
                                    controls={true}
                                    volume={1}
                                    width="300px"
                                    height="auto"
                                    style={{ margin: "0 auto" }}
                                  /> : "No video uploaded"
                                  }
                                </td>
                                
                              </tr>
                            ))}
                            </tbody>
                          </table>
                        
                      </div>
                    </div>
                      <div id="react-paginate">
                        <ReactPaginate
                          breakLabel="..."
                          nextLabel="next >"
                          onPageChange={handlePageClick}
                          pageRangeDisplayed={3}
                          pageCount={pageCount}
                          previousLabel="< previous"
                          renderOnZeroPageCount={null}
                          breakLinkClassName={"page-link"}
                          containerClassName={"pagination"}
                          pageLinkClassName={"page-link"}
                          previousLinkClassName={"page-link"}
                          nextLinkClassName={"page-link"}
                          activeClassName={"active"}
                        />
                      </div>
                    </>
                  ) : (
                    <>
                      <div className="card card-bg head-line mb-3">
                        <div className="text-light d-flex justify-content-center">
                          <h4 className="text-white p-2">
                            Greetings Completed List
                          </h4>
                        </div>
                      </div>

                      <div className="row justify-content-center align-items-center">
                        <div className="d-flex col-md-12 justify-content-center align-items-center my-5">
                          <img src={Nodata} alt="" className=" Nodata" />
                        </div>
                      </div>
                    </>
                  )}
                </div>

                <div className="col-md-5">
                  <div className="card card-bg px-3 py-3">
                    <div className="card card-bg head-line mb-2 ">
                      <div className="text-light d-flex justify-content-center p-2">
                        <div className="faTrophy">
                          <i className="fas fa-trophy"></i>
                        </div>
                        <h4 className="mx-3 text-white p-2">
                          {greeting?.title}
                        </h4>
                      </div>
                    </div>
                    {/* <h4 className="text-light">{greeting?.title}</h4> */}
                    <p className="text-light pt-1">
                      <Markup content={greeting?.instruction} />
                    </p>
                  </div>
                  <div className="row">
                    <div className="col-md-12">
                      <div
                        className="d-flex justify-content-center border border-warning bg-dark mt-3 p-2 buTon-a "
                        style={{ width: "100%" }}
                      >
                        <span>
                          <img src={PriceTag} alt="" className="PriceTage" />
                        </span>
                        <div className=" mx-2 ">
                          <span className="text-light buTon-ab ">Cost</span>
                          <br></br>
                          <span className="text-info fw-bold buTon-abc">
                            {greeting?.cost} $
                          </span>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-12">
                      <div
                        className="d-flex justify-content-center border border-warning bg-dark mt-3 p-2 buTon-a "
                        style={{ width: "100%" }}
                      >
                        <span>
                          <img src={PriceTag} alt="" className="PriceTage" />
                        </span>
                        <div className=" mx-2 ">
                          <span className="text-light buTon-ab ">
                            Minimum apply before
                          </span>
                          <br></br>
                          <span className="text-info fw-bold buTon-abc">
                            {greeting?.user_required_day} Day
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {/* <div className="col-md-5">
                <ReactPlayer
                  className="ReactNAv"
                  url={
                    greeting?.video
                      ? serverUrl + greeting?.video
                      : "https://www.youtube.com/watch?v=-X4ikwUwxoE"
                  }
                  width="100%"
                  // height="100%"
                  playing={false}
                  volume={1}
                  controls={true}
                  autoPlay
                />
                <div className="card card-bg px-3 pb-4 mt-3">
                  <div className="card card-bg head-line mb-2 mt-4 mb-2">
                    <div className="text-light d-flex justify-content-center p-2">
                      <div className="faTrophy">
                        <i className="fas fa-trophy"></i>
                      </div>
                      <h4 className="mx-3 text-white p-2">{greeting?.title}</h4>
                    </div>
                  </div>
                  <p className="text-light pt-1">
                    <Markup content={greeting?.instruction} />
                  </p>
                </div>
                <div
                  className="d-flex justify-content-center border border-warning bg-dark mt-3 p-2 buTon-a "
                  style={{ width: "100%" }}
                >
                  <span>
                    <img src={PriceTag} alt="" className="PriceTage" />
                  </span>
                  <div className=" mx-2 ">
                    <span className="text-light buTon-ab ">Cost</span>
                    <br></br>
                    <span className="text-info fw-bold buTon-abc">
                      {greeting?.cost} $
                    </span>
                  </div>
                </div>
                <div
                  className="d-flex justify-content-center border border-warning bg-dark mt-3 p-2 buTon-a "
                  style={{ width: "100%" }}
                >
                  <span>
                    <img src={PriceTag} alt="" className="PriceTage" />
                  </span>
                  <div className=" mx-2 ">
                    <span className="text-light fw-bold buTon-ab ">
                      Minimum apply before
                    </span>
                    <br></br>
                    <span className="text-info buTon-abc">
                      {greeting?.user_required_day} Day
                    </span>
                  </div>
                </div>
              </div> */}
              </div>
            </>
          ) : (
            <>
              <div className="mx-2 row justify-content-center align-items-center">
                <div className="d-flex col-md-12 justify-content-center align-items-center my-5">
                  <img src={Nodata} alt="" className=" Nodata" />
                </div>
              </div>
            </>
          )}
        </>
      )}
    </>
  );
};

export default StarGreetingsCompletedList;
